import { API } from '../constants/constants';

export const getServiceById = async (id) => {
  try {
    const response = await API.get(`/services/${id}`);
    if (response.status === 204) {
      return 'noData';
    }
    return response.data;
  } catch (e) {
    return { error: 1, message: e.message };
  }
};

export const getMonthlyServices = async (month, timezoneOffset, isCalendarEvent = false) => {
  const res = await API.get('/services/monthly', {
    params: {
      month,
      timezoneOffset,
      isCalendarEvent,
    },
  });
  return res.data;
};

export const createService = async (fields) => {
  const res = await API.post(`/services`, [fields]);
  return res;
};

export const uploadServiceFiles = async ({ id, files }) => {
  const formData = new FormData();
  files
    .filter((file) => file.type !== 'url' && file.type !== 'autotrackerAttachment')
    .forEach((file) => formData.append('file', file));

  return API.post(`/service/${id}/upload`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

export const uploadServiceUrl = async ({ id, file }) => {
  return API.post(`/service/${id}/url`, file);
};

export const updateServiceWithFiles = async ({
  id,
  fields,
  uploadingFiles,
  uploadingUrls,
  removingFiles,
  removingUrls,
}) => {
  const formData = new FormData();

  for (const file of uploadingFiles) {
    formData.append('file', file);
  }
  formData.append('urls', JSON.stringify(uploadingUrls));
  formData.append('deletingFiles', JSON.stringify(removingFiles));
  formData.append('deletingUrls', JSON.stringify(removingUrls));

  const normalizedFields = { ...fields };
  normalizedFields.linkedInteraction = normalizedFields.linkedInteraction?.interactions
    ? normalizedFields.linkedInteraction.interactions
    : normalizedFields.linkedInteraction;
  normalizedFields.linkedEngagement = normalizedFields.linkedEngagement?.engagements
    ? normalizedFields.linkedEngagement.engagements
    : normalizedFields.linkedEngagement;

  formData.append('fields', JSON.stringify(normalizedFields));

  const res = await API.put(`/services/${id}/update`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return res.data;
};

export const deleteService = async (id) => {
  const res = await API.delete(`/services/${id}`);
  return res.data;
};

export const getFilteredServices = async (filterQueryString) => {
  const res = await API.get(`services/filter?${filterQueryString}`);
  return res.data?.data;
};

export const getFuzzySearchServices = async (queryString, category) => {
  const res = await API.get(`/services/fuzzySearch?queryString=${queryString}&category=${category}`);
  return res.data?.data;
};
